/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Airline
 */
export interface Airline {
    /**
     * 
     * @type {string}
     * @memberof Airline
     */
    airlineId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Airline
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Airline
     */
    iatAcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Airline
     */
    icaOcode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Airline
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Airline
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Airline
     */
    smallLogo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Airline
     */
    largeLogo?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Airline
     */
    enabled?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof Airline
     */
    effectiveDateFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof Airline
     */
    effectiveDateTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof Airline
     */
    updatedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Airline
     */
    updatedDate?: Date;
}

export function AirlineFromJSON(json: any): Airline {
    return AirlineFromJSONTyped(json, false);
}

export function AirlineFromJSONTyped(json: any, ignoreDiscriminator: boolean): Airline {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'airlineId': !exists(json, 'airlineId') ? undefined : json['airlineId'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'iatAcode': !exists(json, 'iatAcode') ? undefined : json['iatAcode'],
        'icaOcode': !exists(json, 'icaOcode') ? undefined : json['icaOcode'],
        'fullName': !exists(json, 'fullName') ? undefined : json['fullName'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'smallLogo': !exists(json, 'smallLogo') ? undefined : json['smallLogo'],
        'largeLogo': !exists(json, 'largeLogo') ? undefined : json['largeLogo'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'effectiveDateFrom': !exists(json, 'effectiveDateFrom') ? undefined : json['effectiveDateFrom'],
        'effectiveDateTo': !exists(json, 'effectiveDateTo') ? undefined : json['effectiveDateTo'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'updatedDate': !exists(json, 'updatedDate') ? undefined : (new Date(json['updatedDate'])),
    };
}

export function AirlineToJSON(value?: Airline | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'airlineId': value.airlineId,
        'allowEdit': value.allowEdit,
        'iatAcode': value.iatAcode,
        'icaOcode': value.icaOcode,
        'fullName': value.fullName,
        'name': value.name,
        'smallLogo': value.smallLogo,
        'largeLogo': value.largeLogo,
        'enabled': value.enabled,
        'effectiveDateFrom': value.effectiveDateFrom,
        'effectiveDateTo': value.effectiveDateTo,
        'updatedBy': value.updatedBy,
        'updatedDate': value.updatedDate === undefined ? undefined : (value.updatedDate.toISOString()),
    };
}


